module.exports = __webpack_public_path__ + "img/2.8a3443b2.jpg";